export const API_INIT_EVENT = 'init';
